import Advertisement from "../../components/user/Advertisement";

import UserLayout from "../../components/UserLayout";

const AdvertisementPage = () => {
    return (
        <UserLayout>
            <Advertisement />
        </UserLayout>
    );
}

export default AdvertisementPage;